import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <div className="footer-logo">
                            <img
                                src="/logo.svg"
                                alt="Avenis Global"
                                className="footer-logo-image"
                            />
                            <div className="footer-logo-text">
                                <span className="footer-avenis-text">
                                    AVENIS
                                </span>
                                <span className="footer-global-text">
                                    GLOBAL
                                </span>
                            </div>
                        </div>
                        <p>
                            <span className="slogan-highlight">
                                Avenis is your new avenue to smarter selling.
                            </span>
                            Authorized retail partnership with 100% MAP
                            compliance, brand-safe content, and transparent
                            operations across premium e-commerce channels.
                        </p>
                    </div>

                    <div className="footer-section">
                        <h4>Company</h4>
                        <ul>
                            <li>
                                <Link
                                    to="/services"
                                    onClick={() => window.scrollTo(0, 0)}
                                >
                                    Services
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/about"
                                    onClick={() => window.scrollTo(0, 0)}
                                >
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/contact"
                                    onClick={() => window.scrollTo(0, 0)}
                                >
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Legal</h4>
                        <ul>
                            <li>
                                <Link
                                    to="/privacy-policy"
                                    onClick={() => window.scrollTo(0, 0)}
                                >
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/terms-of-service"
                                    onClick={() => window.scrollTo(0, 0)}
                                >
                                    Terms of Service
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/data-protection"
                                    onClick={() => window.scrollTo(0, 0)}
                                >
                                    Data Protection
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Contact</h4>
                        <div className="company-info">
                            <div className="company-name">
                                Avenis Global LLC
                            </div>
                            <div className="company-address">
                                7901 4th St N Ste 300
                                <br />
                                St. Petersburg, Florida, 33702
                            </div>
                            <div className="company-phone">
                                <a
                                    href="tel:+17276775939"
                                    className="footer-contact-link"
                                >
                                    +1 (727) 677-5939
                                </a>
                            </div>
                            <div className="company-email">
                                <a
                                    href="mailto:sales@avenisglobal.com"
                                    className="footer-contact-link"
                                >
                                    sales@avenisglobal.com
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>
                        &copy; {new Date().getFullYear()} Avenis Global. All
                        rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
